var draggableSlider = (() => {
  var initSlider = (slider) => {
    let isDown = false;
    let startX;
    let startY;
    let scrollLeft;
    let scrollTop;

    slider.querySelectorAll("a, img").forEach((element) => {
      element.setAttribute("draggable", "false");
    });

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      startY = e.pageY - slider.offsetTop;
      scrollLeft = slider.scrollLeft;
      scrollTop = slider.scrollTop;
      slider.style.cursor = "grabbing";
    });

    // slider.addEventListener('mouseleave', () => {
    //   isDown = false;
    //   slider.style.cursor = 'grab';
    // });

    document.addEventListener("mouseup", (e) => {
      isDown = false;
      slider.style.cursor = "grab";
      slider.querySelectorAll("a").forEach((element) => {
        element.style.pointerEvents = "auto";
      });
    });

    document.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      slider.querySelectorAll("a").forEach((element) => {
        element.style.pointerEvents = "none";
      });
      const x = e.pageX - slider.offsetLeft;
      const y = e.pageY - slider.offsetTop;
      const walkX = (x - startX) * 1; // Change this number to adjust the scroll speed
      const walkY = (y - startY) * 1; // Change this number to adjust the scroll speed
      slider.scrollLeft = scrollLeft - walkX;
      slider.scrollTop = scrollTop - walkY;
    });
  };
  var initialize = () => {
    document.querySelectorAll("[js-draggable-slider]").forEach((element) => {
      initSlider(element);
    });
  };
  return {
    init: initialize,
  };
})();

var bundlePickerApp = (() => {
  var updateATC = () => {
    const atcText = document.querySelector("[js-bundle-product-section] [data-add-to-cart-text]");
    if (!atcText) return;
    if (
      document.querySelectorAll("[js-bundle-picker-open].selected").length ===
      document.querySelectorAll("[js-bundle-picker-open]").length
    ) {
      atcText.innerHTML = atcText.getAttribute("data-enabled-text");
      atcText.classList.remove("disabled");
    } else {
      atcText.innerHTML = atcText.getAttribute("data-disabled-text");
      atcText.classList.add("disabled");
    }
  };
  var selectProduct = (element) => {
    if (!element) return;
    const container = element.closest("[js-bundle-picker-dropdown]");
    if (!container) return;
    const picker = document.querySelector(
      `[js-bundle-picker-open][data-index="${container.getAttribute("data-index")}"]`
    );
    if (!picker) return;
    picker.setAttribute("data-variant-id", element.getAttribute("data-variant-id"));
    const selectedInfo = picker.querySelector("[js-selected-info]");
    if (!selectedInfo) return;
    selectedInfo.innerHTML = element.innerHTML;
    picker.classList.add("selected");
    const selectedLabel = document.querySelector("[js-selected-label]");
    if (selectedLabel) {
      selectedLabel.innerHTML = selectedLabel
        .getAttribute("js-selected-label")
        .replace("((value))", document.querySelectorAll("[js-bundle-picker-open].selected").length);
    }
    updateATC();
  };
  var deselectProduct = (element) => {
    if (!element) return;
    element.classList.remove("selected");
    element.removeAttribute("data-variant-id");
    const selectedInfo = element.querySelector("[js-selected-info]");
    if (!selectedInfo) return;
    selectedInfo.innerHTML = "";
    const selectedLabel = document.querySelector("[js-selected-label]");
    if (selectedLabel) {
      selectedLabel.innerHTML = selectedLabel
        .getAttribute("js-selected-label")
        .replace("((value))", document.querySelectorAll("[js-bundle-picker-open].selected").length);
    }
    updateATC();
  };
  var submit = (element) => {
    const quantityError = document.querySelector("[data-quantity-error]");
    if (quantityError) quantityError.classList.add("hidden");
    const atcText = document.querySelector("[data-add-to-cart-text]");
    if (
      !atcText ||
      atcText.classList.contains("disabled") ||
      document.querySelectorAll("[js-bundle-picker-open].selected").length !==
        document.querySelectorAll("[js-bundle-picker-open]").length
    )
      return;
    element.classList.add("loading");
    let idList = [];
    const pdp = document.querySelector("[js-fayn_pdp][data-current-product-id]");
    if (!pdp) return;
    idList.push(pdp.getAttribute("data-current-product-id"));
    document.querySelectorAll("[js-bundle-picker-open][data-variant-id]").forEach((element) => {
      idList.push(element.getAttribute("data-variant-id"));
    });
    window.cart
      .addItemByIdListForBundle(idList)
      .then(() => {
        element.classList.remove("loading");
      })
      .catch((e) => {
        if (quantityError) quantityError.classList.remove("hidden");
        element.classList.remove("loading");
      });
  };
  var initialize = () => {
    document
      .querySelectorAll("[js-bundle-picker-dropdown] [js-bundle-product-variant]")
      .forEach((element) => {
        element.addEventListener("click", () => {
          if (!element.classList.contains("disabled")) selectProduct(element);
        });
      });
    document.querySelectorAll("[js-bundle-picker-open]").forEach((element) => {
      element.addEventListener("click", () => {
        if (
          element.classList.contains("selected") &&
          element.querySelector("[js-selected-info]>*")
        ) {
          deselectProduct(element);
        }
      });
    });
    document
      .querySelectorAll("[js-bundle-product-section] [data-add-to-cart]")
      .forEach((element) => {
        element.addEventListener("click", () => {
          submit(element);
        });
      });
    updateATC();
  };
  return {
    init: initialize,
  };
})();

var app = (() => {
  var initialize = () => {
    draggableSlider.init();
    variantDiscountCodeContentApp.init();
    bundlePickerApp.init();
  };
  return {
    init: initialize,
  };
})();

document.addEventListener("DOMContentLoaded", () => {
  app.init();
});

var variantDiscountCodeContentApp = (() => {
  var update = (variant) => {
    document
      .querySelectorAll("[js-variant-discount-code-content][data-variant-id]")
      .forEach((element) => {
        if (element.getAttribute("data-variant-id") === String(variant.id)) {
          element.classList.add("active");
        } else {
          element.classList.remove("active");
        }
      });
  };
  var checkAvailability = (element) => {
    if (!element) return;
    const startDate = new Date(element.getAttribute("data-promotion-start-datetime"));
    const endDate = new Date(element.getAttribute("data-promotion-end-datetime"));
    const now = new Date();
    const UTCNow = new Date(now.toISOString());
    const startDateValue = startDate.getTime();
    const endDateValue = endDate.getTime();
    const UTCNowValue = UTCNow.getTime();
    if (!Number.isInteger(startDateValue) && !Number.isInteger(endDate)) {
      element.remove();
    } else {
      if (
        (!Number.isInteger(startDateValue) || UTCNowValue >= startDateValue) &&
        (!Number.isInteger(endDateValue) || UTCNowValue <= endDateValue)
      ) {
        element.classList.remove("not-available");
      } else {
        element.remove();
      }
    }
  };
  var initialize = () => {
    document
      .querySelectorAll("[js-variant-discount-code-content], [js-collection-discount-code-content]")
      .forEach((element) => {
        checkAvailability(element);
      });
  };
  return {
    init: initialize,
    update: update,
  };
})();

document.addEventListener("product:variant-change", (data) => {
  variantDiscountCodeContentApp.update(data.detail.variant);
});
